import React, { useContext } from 'react';

import './mega-menu.css';
import * as styles from './mega-menu.module.css';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { TheAppContext } from 'provider/AppContext';
import Contact from '../LightBox/ContactForm/Contact';
import { menuItems } from '../../../data/menu/menu';

const Menu = () => {
  const { setBoxShowing, setMenuOpen } = useContext(TheAppContext);

  return (
    <div className={styles.header__menu}>
      {menuItems.map((item, index) => (
        <div
          className={styles.main_item + ' main_item'}
          key={`${item.id}--${index}`}
        >
          <div className={styles.main_item__title + ' underliney'}>
            {item.displayName} <ArrowDropDownCircleIcon className="down-icon" />
          </div>
          <ul>
            <div
              className={
                styles.sub_menu__block + ' ' + styles[item.customClasses[0]]
              }
            >
              {item.items &&
                item.items.map((l, index) => (
                  <ul className={l.customClasses[0]} key={`${l.id}--${index}`}>
                    {l.id === 'contact' ? (
                      <div
                        onClick={() =>
                          setBoxShowing({
                            visible: true,
                            component: <Contact />,
                          })
                        }
                      >
                        {l.displayName}
                      </div>
                    ) : (
                      <a
                        className={'hover-purp'}
                        href={l.link}
                        target={l.link.startsWith('/') ? '_top' : '_blank'}
                      >
                        {l.displayName}
                      </a>
                    )}
                    {l.items.map((i, index) =>
                      i.info ? (
                        <a
                          href={i.link}
                          key={`${index}`}
                          onClick={() => {
                            setMenuOpen(false);
                          }}
                        >
                          <li className={l.customClasses[0]}>
                            {i.displayName}
                          </li>
                        </a>
                      ) : (
                        <a
                          href={i.link}
                          key={`${l.index}--${index}`}
                          target={l.link.startsWith('/') ? '_top' : '_blank'}
                        >
                          <li className={l.customClasses[0]}>
                            {i.displayName}
                          </li>
                        </a>
                      ),
                    )}
                  </ul>
                ))}
            </div>
          </ul>
        </div>
      ))}
    </div>
  );
};

export default Menu;
